import type { VideoPlaylist } from 'pkg/api/models/video_playlist';

export function isNew(playlist: VideoPlaylist): boolean {
	return playlist.createdAt + 3600 * 24 > Math.floor(Date.now() / 1000);
}
